"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyQuestionnaireByMap = void 0;
var lodash_1 = require("lodash");
var uuid_1 = require("uuid");
var node_1 = require("../questionnaire/node");
var publish_1 = require("../logic/publish");
var group_1 = require("../questionnaire/group");
var constants_1 = require("../constants");
// helper function
var handleOutcome = function (_a) {
    var outcome = _a.outcome, _b = _a.errorPrefix, errorPrefix = _b === void 0 ? 'Outcome' : _b, _c = _a.nodeMap, nodeMap = _c === void 0 ? {} : _c;
    var nodeId = lodash_1.get(outcome, 'params.id');
    var targetNodeId;
    if (nodeId === constants_1.FinalNode) {
        targetNodeId = nodeId;
    }
    else {
        targetNodeId = lodash_1.get(nodeMap, nodeId + ".newRefId");
    }
    if (lodash_1.isUndefined(targetNodeId)) {
        throw new Error(errorPrefix + ": There was no provided 'newRefId' for node with refId: " + nodeId);
    }
    return __assign(__assign({}, outcome), { params: {
            id: targetNodeId,
        } });
};
var handleRule = function (_a) {
    var rule = _a.rule, sourceNodeId = _a.sourceNodeId, _b = _a.errorPrefix, errorPrefix = _b === void 0 ? 'Rule' : _b, _c = _a.nodeMap, nodeMap = _c === void 0 ? {} : _c;
    if (lodash_1.isUndefined(rule))
        return;
    var newRule = __assign(__assign({}, rule), { id: uuid_1.v1() });
    var conditions = handleConditions({
        conditions: rule.conditions,
        sourceNodeId: sourceNodeId,
        errorPrefix: errorPrefix,
        nodeMap: nodeMap,
    });
    if (conditions) {
        newRule.conditions = conditions;
    }
    return newRule;
};
var handleConditions = function (_a) {
    var conditions = _a.conditions, sourceNodeId = _a.sourceNodeId, _b = _a.errorPrefix, errorPrefix = _b === void 0 ? 'Condition' : _b, _c = _a.nodeMap, nodeMap = _c === void 0 ? {} : _c;
    if (lodash_1.isUndefined(conditions))
        return;
    var newConditions = lodash_1.map(conditions, function (conditionOrRule) {
        var _a;
        var isRule = !!conditionOrRule.conditions;
        if (isRule) {
            var newRule = __assign(__assign({}, conditionOrRule), { id: uuid_1.v1() });
            var conditions_1 = handleConditions({
                conditions: conditionOrRule.conditions,
                sourceNodeId: sourceNodeId,
                errorPrefix: errorPrefix,
                nodeMap: nodeMap,
            });
            if (conditions_1) {
                newRule.conditions = conditions_1;
            }
            return newRule;
        }
        else {
            var condition = conditionOrRule;
            var newCondition = __assign(__assign({}, condition), { id: uuid_1.v1() });
            var context_1 = handleContext({
                context: condition.context,
                errorPrefix: errorPrefix,
                nodeMap: nodeMap,
            });
            if (context_1) {
                newCondition.context = context_1;
            }
            var value = newCondition.value;
            var referencedNodeId = sourceNodeId;
            if (context_1.contextType === publish_1.QuestionnaireConditionContext.Answer) {
                // we need the old-id not the new-id created by handleContext
                referencedNodeId = condition.context.questionId;
                if (value) {
                    var nodeType = lodash_1.get(nodeMap, referencedNodeId + ".type");
                    var newValue = void 0;
                    switch (nodeType) {
                        case node_1.NODE_TYPES.QUESTION_SINGLE:
                        case node_1.NODE_TYPES.QUESTION_MULTIPLE:
                            {
                                // new-id
                                var targetAnswerId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'answers',
                                    value,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetAnswerId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for answer with refId: " + value);
                                }
                                newValue = targetAnswerId;
                            }
                            break;
                        case node_1.NODE_TYPES.QUESTION_MATRIX_MULTIPLE:
                        case node_1.NODE_TYPES.QUESTION_MATRIX_SINGLE:
                            {
                                var targetRowId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'answers',
                                    value.row,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetRowId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for answer with refId: " + value.row);
                                }
                                var targetColumnId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'scorepoints',
                                    value.column,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetColumnId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for scorepoint with refId: " + value.column);
                                }
                                newValue = { row: targetRowId, column: targetColumnId };
                            }
                            break;
                        case node_1.NODE_TYPES.QUESTION_MATRIX_OPEN_ENDED:
                        case node_1.NODE_TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED:
                        case node_1.NODE_TYPES.QUESTION_MATRIX_CONSTANT_SUM:
                            {
                                var valueProperty = [
                                    node_1.NODE_TYPES.QUESTION_MATRIX_NUMERIC_OPEN_ENDED,
                                    node_1.NODE_TYPES.QUESTION_MATRIX_CONSTANT_SUM,
                                ].includes(nodeType)
                                    ? 'number'
                                    : 'text';
                                var targetRowId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'answers',
                                    value.row,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetRowId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for answer with refId: " + value.row);
                                }
                                var targetColumnId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'matrixColumns',
                                    value.column,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetColumnId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for matrix-column with refId: " + value.column);
                                }
                                newValue = (_a = {
                                        row: targetRowId,
                                        column: targetColumnId
                                    },
                                    _a[valueProperty] = value[valueProperty],
                                    _a);
                            }
                            break;
                        case node_1.NODE_TYPES.QUESTION_MATRIX_SINGLE_BIPOLAR:
                            {
                                var targetRowId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'answers',
                                    value.row,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetRowId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for answer with refId: " + value.row);
                                }
                                newValue = { row: targetRowId, number: value.number };
                            }
                            break;
                        case node_1.NODE_TYPES.QUESTION_RANKING:
                            {
                                var targetRowId = lodash_1.get(nodeMap, [
                                    referencedNodeId,
                                    'answers',
                                    value.row,
                                    'newRefId',
                                ]);
                                if (lodash_1.isUndefined(targetRowId)) {
                                    throw new Error(errorPrefix + ": There was no provided 'newRefId' for answer with refId: " + value.row);
                                }
                                newValue = { row: targetRowId, column: value.column };
                            }
                            break;
                        default:
                            newValue = value;
                    }
                    newCondition.value = newValue;
                }
            }
            else if (context_1.contextType === publish_1.QuestionnaireConditionContext.Concept) {
                var referencedNodeId_1 = condition.context.nodeId;
                var referencedNode = lodash_1.get(nodeMap, referencedNodeId_1);
                if (value) {
                    var conceptNode = lodash_1.find(referencedNode.concepts, [
                        'oldRefId',
                        value,
                    ]);
                    if (!conceptNode) {
                        throw new Error(errorPrefix + ": Missing concept with refId " + value + " from nodeMap");
                    }
                    newCondition.value = conceptNode.newRefId;
                }
            }
            return newCondition;
        }
    });
    return newConditions;
};
var handleContext = function (_a) {
    var context = _a.context, _b = _a.errorPrefix, errorPrefix = _b === void 0 ? 'Context' : _b, _c = _a.nodeMap, nodeMap = _c === void 0 ? {} : _c;
    if (lodash_1.isUndefined(context))
        return;
    if (context.contextType === publish_1.QuestionnaireConditionContext.Answer) {
        // only handles questionid contexts currently
        var questionId = context.questionId;
        var targetQuestionId = lodash_1.get(nodeMap, [questionId, 'newRefId']);
        if (lodash_1.isUndefined(targetQuestionId)) {
            throw new Error(errorPrefix + ": There was no provided 'newRefId' for question with refId: " + questionId);
        }
        return __assign(__assign({}, context), { questionId: targetQuestionId });
    }
    else if (context.contextType === publish_1.QuestionnaireConditionContext.Concept) {
        // only handles questionid contexts currently
        var nodeId = context.nodeId;
        var targetNodeId = lodash_1.get(nodeMap, [nodeId, 'newRefId']);
        if (lodash_1.isUndefined(targetNodeId)) {
            throw new Error(errorPrefix + ": There was no provided 'newRefId' for question with refId: " + nodeId);
        }
        return __assign(__assign({}, context), { nodeId: targetNodeId });
    }
    else if (context.contextType === publish_1.QuestionnaireConditionContext.Taxonomy) {
        return __assign({}, context);
    }
    else {
        throw new Error(errorPrefix + ": Unhandled context type while trying to duplicate. Received " + context.contextType);
    }
};
var transformQuestion = function (_a) {
    var oldQuestion = _a.oldQuestion, targetQuestion = _a.targetQuestion;
    var newQuestion = { id: targetQuestion.newRefId, answers: [] };
    if (!lodash_1.isEmpty(oldQuestion.answers)) {
        var newAnswers = lodash_1.map(oldQuestion.answers, function (answer) {
            var targetAnswerId = lodash_1.get(targetQuestion, [
                'answers',
                answer.id,
                'newRefId',
            ]);
            if (lodash_1.isUndefined(targetAnswerId)) {
                throw new Error("Questionnaire.questions: There was no provided 'newRefId' for answer with refId: '" + answer.id + "'");
            }
            return __assign(__assign({}, answer), { id: targetAnswerId });
        });
        newQuestion.answers = newAnswers;
    }
    return newQuestion;
};
function copyQuestionnaireByMap(ql, nodes, newSurveyId) {
    // generate question refId map
    var nodeMap = Object.assign({
        '-1': {
            oldRefId: '-1',
            newRefId: '-1',
            type: node_1.NODE_TYPES.UNDEFINED,
            answers: {},
            scorepoints: {},
        },
    }, lodash_1.mapValues(lodash_1.keyBy(nodes, 'oldRefId'), function (question) { return (__assign(__assign({}, question), { answers: lodash_1.keyBy(question.answers, 'oldRefId'), scorepoints: lodash_1.keyBy(question.scorepoints, 'oldRefId'), matrixColumns: lodash_1.keyBy(question.matrixColumns, 'oldRefId') })); }));
    // process the Ql
    var copiedQl = {
        entryPoint: { statements: [] },
        questionnaire: { surveyId: 0, nodes: [] },
        nodeStatements: [],
    };
    // update the questionnaire property
    copiedQl.questionnaire.surveyId = newSurveyId;
    copiedQl.questionnaire.nodes = lodash_1.map(ql.questionnaire.nodes, function (node) {
        var target = nodeMap[node.id];
        if (!target) {
            throw new Error("Questionnaire.nodes: There was no replacement provided for node with refId: " + node.id);
        }
        if (group_1.isGroupType(target.type)) {
            var targetNode = node;
            var newGroup = {
                id: target.newRefId,
                nodes: [],
                repetitions: targetNode.repetitions || 1,
            };
            if (target.nodes) {
                newGroup.nodes = target.nodes.map(function (node) { return ({
                    id: node.newRefId,
                    // NOTE: we are currently not storing answers or their ids for nodes within a group
                    answers: [],
                }); });
            }
            return newGroup;
        }
        else {
            var question = node;
            return transformQuestion({
                oldQuestion: question,
                targetQuestion: target,
            });
        }
    });
    // update the entryPoint
    copiedQl.entryPoint.statements = ql.entryPoint.statements.map(function (statement) {
        var outcome = handleOutcome({
            outcome: statement.outcome,
            errorPrefix: 'EntryPoint',
            nodeMap: nodeMap,
        });
        return {
            id: uuid_1.v1(),
            outcome: outcome,
        };
    });
    //update the nodeStatements
    copiedQl.nodeStatements = lodash_1.map(ql.nodeStatements, function (nodeStatement) {
        var nodeId = nodeStatement.nodeId;
        var targetNodeId = lodash_1.get(nodeMap, nodeId + ".newRefId");
        if (lodash_1.isUndefined(targetNodeId)) {
            throw new Error("NodeStatements: There was no provided 'newRefId' for node with refId: " + nodeId);
        }
        return {
            nodeId: targetNodeId,
            statements: lodash_1.map(nodeStatement.statements, function (statement) {
                var newStatement = {
                    id: uuid_1.v1(),
                };
                var outcome = handleOutcome({
                    outcome: statement.outcome,
                    errorPrefix: 'NodeStatements Outcome',
                    nodeMap: nodeMap,
                });
                if (outcome) {
                    newStatement.outcome = outcome;
                }
                if (statement.rule) {
                    var rule = handleRule({
                        rule: statement.rule,
                        sourceNodeId: nodeId,
                        errorPrefix: "NodeStatements Rule " + nodeId,
                        nodeMap: nodeMap,
                    });
                    if (rule) {
                        newStatement.rule = rule;
                    }
                }
                return newStatement;
            }),
        };
    });
    return copiedQl;
}
exports.copyQuestionnaireByMap = copyQuestionnaireByMap;
